export default __webpack_public_path__ + "static/media/001.eb2b8d38.md";